module.exports = __webpack_public_path__ + "img/wechat1.f450e235.jpg";